import PosthogService from '~/services/posthog/PosthogService';

export interface IFavoritesInviteClickedPayload {
  professionalId: string;
}

/**
 * Fires when the user clicks "Invite" from the Favorites tab
 * Event: dental_portal:favorites:invite_clicked
 */
export function fireFavoritesInviteClicked(payload: IFavoritesInviteClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:favorites:invite_clicked', {
    pro_category: 'Favorites',
    professional_id: payload.professionalId,
  });
}
